<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },

    labels: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    hideLeagend: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      series: this.data,
      chartOptions: {
        chart: {
          type: 'pie',
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 240,
            },
            legend: {
              position: 'bottom'
            }
          }
        }],
        labels: this.labels,
        /*title: {
          text: this.title, // Modifier le titre ici
          align: 'left',
          margin: 40,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: '16px',
            color: '#263238'
          },
        },*/
        legend: {
          show: !this.hideLeagend,
        },
      
      },
    };
  },
};
</script>

<template>
  <apexchart
  :height="!this.hideLeagend ? '300' : '250'"
  type="pie" 
    :series="series"
    :options="chartOptions"
  ></apexchart> 
</template>
